import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '../../Constants/Constants';
import { CommonDataService } from '../../services/common-data.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'decimalPrecision',
  pure: true,
  standalone: true
})
export class DecimalPrecisionPipe implements PipeTransform {

  constructor(private readonly commonDataService: CommonDataService,
    private translateService: TranslateService
  ) {}

  transform(value: number | string, overridePrecision?: number): string {
    if (value === null || value === undefined || value === CONSTANTS.EMPTY_STRING) {
      return CONSTANTS.EMPTY_STRING;
    }

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) {
      return value.toString();
    }

    const precision = overridePrecision ?? this.commonDataService.getDecimalPrecision();
    const currentLang = this.translateService.currentLang || this.translateService.defaultLang || CONSTANTS.LANGUAGE_EN_US;
    // Zero is neither positive nor negative, so avoid rendering "-0.00"
    const normalizedValue = Number(numericValue.toFixed(precision)) === 0 ? 0 : numericValue;
    return new Intl.NumberFormat(currentLang, {
      style: 'decimal',
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    }).format(normalizedValue);
  }
}
